<template>
    <div>
        <!-- 搜索框 -->
        <a-card title="流控降级-Service">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-tabs v-model="activekey"  @change="tabChange">
                <a-tab-pane key="1" tab="服务列表">
                    <a-form layout="inline" @submit="handleSubmit" :form="form" style="margin-bottom:20px;">
                        <a-form-item label="所属领域">
                            <a-select v-model="searchP.domain" placeholder="" style="width:120px">
                                <a-select-option value="">
                                    全部
                                </a-select-option>
                                <a-select-option v-for="(item,index) in domainName" :key="index" :value="index">
                                    {{item}}
                                </a-select-option>
                            </a-select>
                        </a-form-item>

                        <a-form-item label="关键字">
                            <a-input v-model="searchP.keyword" allow-clear placeholder="请输入关键字"></a-input>
                        </a-form-item>



                        <a-form-item>
                            <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
                        </a-form-item>
                        <a-form-item>
                            <a-button type="default" htmlType="submit" :key="this.loading.key"
                                @click="handleSearchReset">重置
                            </a-button>
                        </a-form-item>
                    </a-form>
                    <!-- 系统列表 -->
                    <a-table :columns="columns" :data-source="data" :pagination="false" :loading="tLoading" rowKey="id">
                        <span slot="authflag" slot-scope="text">{{flagname[text]}}</span>
                        <template slot="operation" slot-scope="text, record">
                            <div>
                                <span>
                                    <a-button type="link" @click="handle_auth_edit(record)">配置</a-button>
                                </span>
                            </div>


                        </template>
                    </a-table>

                    <a-pagination class="my_pagenation" v-model="pagination.current" :total="pagination.total"
                        @change="handlePageChange" show-less-items show-quick-jumper />
                </a-tab-pane>
                <a-tab-pane key="2" tab="已配置列表" force-render>
                    <allserviceconfiglist></allserviceconfiglist>
                </a-tab-pane>
            </a-tabs>
        </a-card>
    </div>
</template>
<script>
import { mapState } from "vuex";
import allserviceconfiglist from "./allserviceconfiglist"
// import AppAutoComplete from '@/components/AppAutoComplete'
const data = [];
const domainName = {
    '001':'前台',
    '002':'中台',
    '003':'开放',
    '004':'基础',

};
const flagname = {
    '0':'不开启',
    '1':'开启白名单',
    '2':'开启黑名单',

};
let pagination={
    total:0,
    pageSize:0,
    current:1,
}
const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: "所属领域",
        dataIndex: "domaindesc",
        width:80
    },
    {
        title: "应用编码",
        dataIndex: "appcode",
        width:100,

    },
    {
        title: "服务KEY",
        dataIndex: "servicekey",
        width:100
    },
    // {
    //     title: "开启流控",
    //     dataIndex: "authflag",
    //     customRender: text => (text == "1" ? "开启" : "关闭"),
    //     width:80
    // },
    {
        title: "服务配置",
        dataIndex: "serviceconfig",
        width:200
    },
    {
        title: "接口类型",
        dataIndex: "interfacetype",
        width:80
    },
    {
        title: "免鉴权",
        dataIndex: "entry",
        customRender: text => (text == "1" ? "是" : "否"),
        width:80
    },
    {
        title: "创建时间",
        dataIndex: "createtime",
        width:150
    },


    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'operation' },
    }

];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            pagination,
            domainName,
            flagname,
            tLoading:true,
            currentItemList:'',
            datasource:{
                isShow:false,
                authedStr:''
            },
            searchAppcode:'',
            activekey:"1",
        };
    },
    methods: {
        handleSearchAppcodeChange(value){
            this.searchP.appcode = value;
        },
        handlePageChange(c_p){
            this.getAuthedAppList(c_p)
        },
        getAuthedAppList(cpage){
            let {query} = this.$route;
            let c_params = {
                ...this.searchP,
                appcode: query.parentappcode
            }
            c_params.page =cpage ? cpage : 1;
            c_params.pageSize = this.pagination.pageSize;
            c_params.urlparams = false;
            this.tLoading = true;
            this.$store.dispatch({
                type: "servicekey/select",
                params:c_params
            }).then((res)=>{
                this.tLoading = false;
                let result = res.data.data;
                if(result){
                    this.data = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.current = parseInt(result.page);
                }
            })
        },
        tabChange(key){
            this.searchP.activekey = key + ''
        },
        handle_auth_edit(ritem){
            this.$router.push({
                path: "serviceriskconfiglist",
                query: {appcode:ritem.appcode,domain:ritem.domain,servicekey:ritem.servicekey,serviceconfig:ritem.serviceconfig}
            });
        },

        handleSearchReset(){
            this.$store.dispatch({
                type: "servicekey/getEmptySearch",
                showMsg: true
            })
            // this.$refs.shopcodeAsl.setInputVal(this.searchP.appcode);
        },

        handleSubmit(e){
            e.preventDefault();
            this.getAuthedAppList()
        },

    },
    computed:{
        ...mapState('servicekey', {
            searchP: state => state.searchP,
        })
    },
    components:{
        allserviceconfiglist
    },
    mounted(){
        this.searchAppcode = this.searchP.appcode
        // this.$refs.shopcodeAsl.setInputVal(this.searchP.appcode);
        this.activekey = this.searchP.activekey ? this.searchP.activekey : '1'
        this.getAuthedAppList();
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
